import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatLargeNumber',
  standalone: false,
})
export class FormatLargeNumberPipe implements PipeTransform {
  // Unicode directional isolate markers to keep number+suffix
  // as a cohesive LTR unit in RTL layouts (e.g., Arabic)
  private static readonly LRI = '\u2066'; // Left-to-Right Isolate
  private static readonly PDI = '\u2069'; // Pop Directional Isolate

  transform(value: number): string {
    if (value == null || isNaN(value)) {
      return '0';
    }
    let result: string;
    if (value >= 1000000000) {
      result = this.formatDecimal(value / 1000000000) + ' B';
    } else if (value >= 1000000) {
      result = this.formatDecimal(value / 1000000) + ' M';
    } else if (value >= 1000) {
      result = this.formatDecimal(value / 1000) + ' K';
    } else {
      result = this.formatDecimal(value);
    }
    return FormatLargeNumberPipe.LRI + result + FormatLargeNumberPipe.PDI;
  }

  private formatDecimal(n: number): string {
    const rounded = parseFloat(n.toFixed(1));
    return rounded % 1 === 0 ? rounded.toFixed(0) : rounded.toFixed(1);
  }
}
